import React from 'react';
import { useIntl } from 'react-intl';

import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Alert, Link } from '@mui/material';
import { Colors } from '@provider-portal/common/styles/bolt-uikit-colors';
import { FONT_FAMILY } from '@provider-portal/common/styles/themeMui';
import { format } from 'date-fns';

const styles = {
  banAlert: {
    fontFamily: FONT_FAMILY,
    fontSize: '.875rem',
    lineHeight: '1.25rem',
    fontWeight: 400,
    color: Colors.neutral900,
    borderRadius: '8px',
    backgroundColor: Colors.yellow100,
  },
  balAlertIcon: {
    color: Colors.yellow500,
  },
};

const ONE_SECOND_IN_MS = 1000;

interface PromotionCreationAlertProps {
  isSelectedItemsBan?: boolean;
  bannedUntil?: number;
}

export const PromotionCreationAlert = (props: PromotionCreationAlertProps) => {
  const intl = useIntl();
  let alertMessage;
  if (props.isSelectedItemsBan) {
    const selectedItemsAlertMessage = intl.formatMessage({
      id: 'components.wizardSection.selectedItemsAlertMessage',
    });
    const selectedItemsAlertAction = intl.formatMessage(
      {
        id: 'components.wizardSection.selectedItemsAlertAction',
      },
      {
        myMenu: <strong>{intl.formatMessage({ id: 'components.wizardSection.myMenu' })}</strong>,
        menuEditor: (
          <strong>{intl.formatMessage({ id: 'components.wizardSection.menuEditor' })}</strong>
        ),
      },
    );
    const menuEditorLink = intl.formatMessage(
      { id: 'components.wizardSection.menuEditorLink' },
      {
        menuEditorLink: (
          <Link href="/menu-editor/my-menu" rel="noreferrer">
            {intl.formatMessage({ id: 'components.wizardSection.goToMyMenu' })}
          </Link>
        ),
      },
    );

    alertMessage = (
      <div>
        {selectedItemsAlertMessage}
        <br />
        {selectedItemsAlertAction}
        <br />
        {menuEditorLink}
      </div>
    );
  } else if (props.bannedUntil) {
    const banDate = format(props.bannedUntil * ONE_SECOND_IN_MS, 'MMM dd, yyyy');
    alertMessage = intl.formatMessage(
      {
        id: 'components.wizardSection.banAlertMessage',
      },
      {
        banDate: <strong>{banDate}</strong>,
        fullMenu: (
          <strong>{intl.formatMessage({ id: 'components.wizardSection.fullMenu' })}</strong>
        ),
        selectedItems: (
          <strong>{intl.formatMessage({ id: 'components.wizardSection.selectedItems' })}</strong>
        ),
      },
    );
  }

  return (
    <Alert
      severity="info"
      icon={<WarningRoundedIcon sx={styles.balAlertIcon} />}
      sx={styles.banAlert}
    >
      {alertMessage}
    </Alert>
  );
};
